import React from "react";
import Video from "../../../components/faceswap/Video.jsx/Video";

export default function Videos() {
  return <Video />;
}
